import { createContext, useEffect, useState } from 'react';
import { IChildrenProps } from '../Interfaces/IChildrenProps';
import { GetPercentageValidatedFeaturesTechnologies } from '../API/PercentageValidation';
import { useAuth } from 'oidc-react';
import { useParams } from 'react-router-dom';

interface ITechnologicalFeaturesFinepProps {
    handleFillTab: (tab: number, isValidGroupsCount?: number) => void;
    handleUnfillTab: (tab: number, isValidGroupsCount?: number) => void;
    handleValidateTab: (tab: number, valisValidGroupsCountue?: number) => void;
    handleInvalidateTab: (tab: number, isValidGroupsCount?: number) => void;
    handleChangeTab: (event: React.SyntheticEvent, newValue: number) => void;
    changeTab: (newValue: number) => void;
    update: () => void;
    value: number;
    validateModel: typeof tabsToValidate;
    validateValue: number;
    loading: boolean;
}

export const TechnologicalFeaturesFinepContext = createContext({} as ITechnologicalFeaturesFinepProps);

const tabsToValidate = [
    {
        tab: 0,
        totalFields: 4,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 1,
        totalFields: 10,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 2,
        totalFields: 4,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
    {
        tab: 3,
        totalFields: 13,
        validatedsCount: 0,
        validatedsPercentage: 0,
        filledsCount: 0,
        filledsPercentage: 0,
    },
]

export const TechnologicalFeaturesFinepProvider = ({ children }: IChildrenProps) => {
    const [value, setValue] = useState(0);
    const [validateModel, setValidateModel] = useState<typeof tabsToValidate>(tabsToValidate);
    const [validateValue, setValidateValue] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const { registerId } = useParams();
    const auth = useAuth();
    let userData = auth?.userData;

    const handleValidateTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab) {
                if (x.totalFields >= x.validatedsCount + 1) {
                    x.validatedsCount = isValidGroupsCount ? x.validatedsCount + isValidGroupsCount : x.validatedsCount + 1;
                    x.validatedsPercentage = 100 * (x.validatedsCount) / totalFields;
                }
            }
            return x;
        });

        console.log('newModel', newModel);

        setValidateModel(newModel);
    }

    const handleInvalidateTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce((acc, obj) => acc + obj.totalFields, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab) {

                if (x.validatedsCount - 1 > 0) {
                    x.validatedsCount = isValidGroupsCount ? x.validatedsCount - isValidGroupsCount : x.validatedsCount - 1;
                    x.validatedsPercentage = 100 * (x.validatedsCount) / totalFields;
                }
            }
            return x;
        });
        setValidateModel(newModel);
    }

    const handleFillTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce(function (acc, obj) {
            return acc + obj.totalFields;
        }, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.totalFields >= x.filledsCount + 1) {
                    x.filledsCount = isValidGroupsCount != undefined ? x.filledsCount + isValidGroupsCount : x.filledsCount + 1;
                    x.filledsPercentage = 100 * (x.filledsCount) / totalFields;
                }

            return x;
        });
        setValidateModel(newModel);
    }

    const handleUnfillTab = (tab: number, isValidGroupsCount?: number) => {
        const totalFields = validateModel.reduce(function (acc, obj) {
            return acc + obj.totalFields;
        }, 0);

        const newModel = validateModel.map(x => {
            if (x.tab === tab)
                if (x.filledsCount - 1 > 0) {
                    x.filledsCount = isValidGroupsCount ? x.filledsCount - isValidGroupsCount : x.filledsCount - 1;
                    x.filledsPercentage = 100 * (x.filledsCount) / totalFields;
                }

            return x;
        });
        setValidateModel(newModel);
    }

    const handleChangeTab = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
    };

    const changeTab = (newValue: number) => {
        setValue(newValue);
    };

    const update = () => {
        getValidates();
    }

    const getValidates = async () => {
        setLoading(true);
        
        await GetPercentageValidatedFeaturesTechnologies(registerId!, userData?.access_token!)
            .then(x => setValidateValue(x.data))
            .catch(x => setValidateValue(0));
        setLoading(false);
    }

    useEffect(() => {
        getValidates();
    }, [])

    return (
        <>
            <TechnologicalFeaturesFinepContext.Provider
                value={{
                    value,
                    validateModel,
                    validateValue,
                    loading,
                    handleFillTab,
                    handleUnfillTab,
                    handleChangeTab,
                    handleValidateTab,
                    handleInvalidateTab,
                    changeTab,
                    update
                }}>
                {children}
            </TechnologicalFeaturesFinepContext.Provider>
        </>
    )
}

